module.exports = __webpack_public_path__ + "static/img/info-warning.b4411422.svg";